export default __webpack_public_path__ + "static/IMMORTAL-f508e0156a6a6236f0760aab3e338cd3.woff";